import {
	FormControl,
	FormDescription,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/components/ui/form';

import { Input } from '@/components/ui/input';
import _ from 'lodash';
import { useFormContext } from 'react-hook-form';

interface NumberFieldProps {
	name: string;
	label?: string;
	description?: string;
	min?: number;
	max?: number;
	step?: number;
	placeholder?: string;
	symbol?: {
		prefix?: string;
		suffix?: string;
	};
}

export function GroupPricingNumberField({
	name,
	label,
	description,
	min,
	max,
	step = 1,
	placeholder,
	symbol,
}: NumberFieldProps) {
	const form = useFormContext();

	return (
		<div className='tw-space-y-2'>
			<FormField
				control={form.control}
				name={name}
				render={({ field }) => (
					<FormItem>
						<FormLabel>
							{label ?? _.startCase(name)}{' '}
							{(symbol?.prefix || symbol?.suffix) && (
								<span className='tw-text-muted-foreground tw-ml-2'>
									{symbol?.prefix}
									{field.value}
									{symbol?.suffix}
								</span>
							)}
						</FormLabel>
						<FormControl>
							<div className='tw-flex tw-items-center tw-space-x-2'>
								{symbol?.prefix && (
									<span className='tw-text-sm'>{symbol.prefix}</span>
								)}
								<Input
									className='tw-bg-white hover:tw-bg-secondary'
									type='number'
									min={min}
									max={max}
									step={step}
									placeholder={placeholder}
									{...field}
									onChange={(e) => {
										const value = e.target.value;
										field.onChange(value === '' ? '' : Number(value));
									}}
									onBlur={() => {
										if (field.value === '') {
											field.onChange(0);
										}
									}}
								/>
								{symbol?.suffix && (
									<span className='tw-text-sm'>{symbol.suffix}</span>
								)}
							</div>
						</FormControl>
						<FormDescription>{description}</FormDescription>
						<FormMessage />
					</FormItem>
				)}
			/>
		</div>
	);
}
